const arrayParser=(item)=>{
    let lengthArray=item.length
    let remainingItems= lengthArray
    let parsedArrayString=" "
    if (lengthArray>0)
        {
        item.forEach(text => {
            parsedArrayString += text
            remainingItems --  
            if (remainingItems > 1)
                {
                parsedArrayString += ", " 
                }
            else if (remainingItems === 1)
                {
                parsedArrayString += " & "
                }
            else {parsedArrayString += "" 
                 }
            })
        }


return parsedArrayString
    }


export default arrayParser